/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { RoleSummary, RoleSummary$inboundSchema } from "./rolesummary.js";
import { UserSummary, UserSummary$inboundSchema } from "./usersummary.js";

/**
 * Result of searching user usage summaries
 */
export type SearchUsersResult = {
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
  /**
   * List of role usage summaries (populated when group_by=role)
   */
  roles?: Array<RoleSummary> | undefined;
  /**
   * List of user usage summaries (populated when group_by=employee)
   */
  users: Array<UserSummary>;
};

/** @internal */
export const SearchUsersResult$inboundSchema: z.ZodMiniType<
  SearchUsersResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    roles: z.optional(z.array(RoleSummary$inboundSchema)),
    users: z.array(UserSummary$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function searchUsersResultFromJSON(
  jsonString: string,
): SafeParseResult<SearchUsersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SearchUsersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchUsersResult' from JSON`,
  );
}
